import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import SearchMenu from './searchMenu';
import {
    getQcReportDisplayModeLabel,
    getQcReportResultStatusLabel,
    getQcReportSampleStatusLabel,
    getQcReportViewModeLabel,
    getUserDetails
} from '../../../../services/common/util';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import {
    ALL_CONTROL_TYPES_ID,
    ALL_CONTROL_TYPES_LABEL,
    ALL_INSTRUMENTS_LABEL,
    ALL_LOT_NUMBERS_ID,
    ALL_LOT_NUMBERS_LABEL,
    ALL_SAMPLES_LABEL,
    auditEnums,
    serviceConstants
} from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { fetchQcReports } from '../../../../services/clinicPortalServices/qcReportService';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import EditBtnCellRenderer from './editBtnCellRenderer';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class QcReportGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions',
                    minWidth: 150,
                    maxWidth: 150,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Analyte',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyte ? params.data.analyte.name : '';
                    }
                },

                {
                    headerName: 'Control Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'controlType',
                    valueGetter: (params) => {
                        return params.data.controlType
                            ? params.data.controlType === ALL_CONTROL_TYPES_ID
                                ? ALL_CONTROL_TYPES_LABEL
                                : params.data.controlType
                            : '-';
                    }
                },
                {
                    headerName: 'Lot Number',
                    minWidth: 150,
                    resizable: true,
                    field: 'lotNumber',
                    valueGetter: (params) => {
                        return params.data.lotNumber
                            ? params.data.lotNumber === ALL_LOT_NUMBERS_ID
                                ? ALL_LOT_NUMBERS_LABEL
                                : params.data.lotNumber
                            : '-';
                    }
                },
                {
                    headerName: 'QC Sample ID',
                    minWidth: 150,
                    resizable: true,
                    field: 'qcSample',
                    valueGetter: (params) => {
                        return params.data.qcSample?.selectedItem
                            ? params.data.qcSample?.selectedItem.name
                            : params.data.qcSample.isAll
                            ? ALL_SAMPLES_LABEL
                            : '-';
                    }
                },
                {
                    headerName: 'Date Range',
                    minWidth: 150,
                    resizable: true,
                    field: 'dateRange',
                    valueGetter: (params) => {
                        return params.data.fromDate && params.data.toDate
                            ? `${moment(params.data.fromDate).format('MM/DD/YYYY')} - ${moment(
                                  params.data.toDate
                              ).format('MM/DD/YYYY')}`
                            : '';
                    }
                },
                {
                    headerName: 'Sample Status',
                    minWidth: 150,
                    resizable: true,
                    field: 'sampleStatus',
                    valueGetter: (params) => {
                        return params.data.sampleStatus ? getQcReportSampleStatusLabel(params.data.sampleStatus) : '-';
                    }
                },
                {
                    headerName: 'Result Status',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultStatus',
                    valueGetter: (params) => {
                        return params.data.resultStatus ? getQcReportResultStatusLabel(params.data.resultStatus) : '-';
                    }
                },
                {
                    headerName: 'Instrument',
                    minWidth: 150,
                    resizable: true,
                    field: 'instrument',
                    valueGetter: (params) => {
                        return params.data.instrument?.selectedItem
                            ? params.data.instrument.selectedItem.name
                            : params.data.instrument.isAll
                            ? ALL_INSTRUMENTS_LABEL
                            : '-';
                    }
                },
                {
                    headerName: 'Display Mode',
                    minWidth: 150,
                    resizable: true,
                    field: 'displayMode',
                    valueGetter: (params) => {
                        return params.data.displayMode ? getQcReportDisplayModeLabel(params.data.displayMode) : '-';
                    }
                },
                {
                    headerName: 'View Mode',
                    minWidth: 150,
                    resizable: true,
                    field: 'viewMode',
                    valueGetter: (params) => {
                        return params.data.viewMode ? getQcReportViewModeLabel(params.data.viewMode) : '-';
                    }
                },
                {
                    headerName: 'Creation Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.createdAt
                            ? moment
                                  .tz(params.data.createdAt, serviceConstants.SYSTEM_TIME_ZONE)
                                  .format('MM/DD/YYYY hh:mm:ss A')
                            : '';
                    }
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this },
            qcRanges: [],
            qcReports: []
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        fetchQcReports().then((res) => {
            this.setState({ rowData: res.data });
        });
        fetchQcRanges().then((res) => {
            this.setState({ qcRanges: res.data });
        });
        fetchQcReports().then((res) => {
            this.setState({ qcReports: res.data });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'QC_Result_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'QC Results'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.QcReportGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.QcReportGridExported
        };
        createAudit(auditData);
    };

    render() {
        let columnDefs = this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default QcReportGrid;
